/** matches polyfill */

(function(e) {
  e.matches ||
    (e.matches =
      e.matchesSelector ||
      function(selector) {
        const matches = document.querySelectorAll(selector)
        const th = this
        return Array.prototype.some.call(matches, (e) => e === th)
      })
})(Element.prototype)



// WEBPACK FOOTER //
// ./src/js/index.js